import { useQuery } from "react-query"
import customAxios from "../utils/customAxios"

const axios = customAxios()

// interface searchProfileType {
//   major: string,
//   lv: string,
//   section: string,
// }

// const fetchProfileApi = ({queryKey}: any ) => {
//   const prop = queryKey[1]
//   console.log('payload: ', prop)
//     return axios.get(`/profile`, prop)
// }
const fetchProfileApi = ({ queryKey }: any) => {
  const prop = queryKey[1]
  return axios.get(
    `/cmat/profile?lv=${prop.lv}&section=${prop.section}&major=${prop.major}`
  )
}

export const useProfileApi = (prop?: any) => {
  return useQuery(["fetchProfileApi", prop], fetchProfileApi, {
    staleTime: 10000,
    select,
    onError,
    refetchOnWindowFocus: false,
    enabled: false,
    // enabled: true,
  })
}

// api 응답 데이터 가공하는 부분
const select = (response: any) => {
  return response.data
}

const onError = (err: any) => {
  return err
}
